var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M97.8 15C79.1-3.6 48.9-3.6 30.2 15c-18.6 18.6-18.6 48.9 0 67.6l33.8 33 33.7-33.1c18.7-18.6 18.7-48.9.1-67.5zm-5.7 61.8L64 104.4 35.9 76.9c-7.5-7.5-11.6-17.5-11.6-28.1s4.1-20.6 11.6-28.1S53.4 9 64 9s20.6 4.1 28.1 11.6 11.6 17.5 11.6 28.1c.1 10.7-4.1 20.6-11.6 28.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M64 28.3c-11.3 0-20.4 9.2-20.4 20.4S52.7 69.2 64 69.2 84.4 60 84.4 48.8 75.3 28.3 64 28.3zm0 32.9c-6.8 0-12.4-5.6-12.4-12.4S57.2 36.3 64 36.3s12.4 5.6 12.4 12.4S70.8 61.2 64 61.2zM27 119h74v8H27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsvg);
export default __webpack_public_path__ + "static/media/mapsvg.d88cecde54cf4d2533ab9946f52af2ff.svg";
export { ForwardRef as ReactComponent };